import React from "react";

export interface IProjectContext {
    project: string;
    url: string;
}
const ProjectContext = React.createContext<IProjectContext | null>(null);

export default ProjectContext;
